<template>
  <div class="menubar-search">
    <Search />
  </div>
</template>

<script>
import Search from '@/layouts/Elements/Search.vue';

export default {
  data: () => ({}),
  computed: {},
  methods: {},
  components: {
    Search,
  }
};
</script>
